export default __webpack_public_path__ + "static/media/exclamation-mark-icon.56205aca.svg";